import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import DateField from "@/components/invoices/DateField";

export default function AdminSettings() {
  const { t } = useTranslation();
  const [o, setO] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/settings/comeback-offer").then((r) => setO(r.data)); }, []);
  if (!o) return <p className="text-sm text-text-secondary text-center py-8">{t("admin.loading")}</p>;
  const set = (k) => (e) => setO({ ...o, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/settings/comeback-offer", o); toast.success(t("admin.saved")); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="card-c space-y-3 max-w-xl" data-testid="admin-settings">
      <p className="font-display text-xl">{t("admin.offer_title")}</p>
      <p className="text-xs text-text-secondary">{t("admin.offer_desc")}</p>
      <label className="flex items-center gap-2 text-sm font-semibold">
        <input type="checkbox" checked={!!o.enabled} onChange={set("enabled")} className="w-5 h-5 accent-[var(--primary)]" data-testid="offer-enabled" />{t("admin.offer_enabled")}
      </label>
      <label className="block text-xs text-text-secondary">{t("admin.offer_text_fr")}
        <textarea value={o.text_fr} onChange={set("text_fr")} maxLength={500} rows={3} className="input-c text-sm mt-1" data-testid="offer-text-fr" /></label>
      <label className="block text-xs text-text-secondary">{t("admin.offer_text_de")}
        <textarea value={o.text_de} onChange={set("text_de")} maxLength={500} rows={3} className="input-c text-sm mt-1" data-testid="offer-text-de" /></label>
      <label className="block text-xs text-text-secondary">{t("admin.offer_code")}
        <input value={o.code} onChange={set("code")} maxLength={40} className="input-c text-sm mt-1" data-testid="offer-code" /></label>
      <div className="text-xs text-text-secondary">{t("admin.offer_valid")}
        <div className="mt-1 flex gap-2 items-center">
          <DateField value={o.valid_until} onChange={(d) => setO({ ...o, valid_until: d })} testId="offer-valid-until" />
          {o.valid_until && <button type="button" onClick={() => setO({ ...o, valid_until: "" })} className="text-xs underline" data-testid="offer-valid-clear">{t("admin.clear")}</button>}
        </div>
      </div>
      <button disabled={busy} onClick={save} className="btn-primary w-full" data-testid="offer-save">{t("admin.save")}</button>
    </div>
  );
}
